import type { contractInput, contractOutput } from '#backend/contract';
import { ReportTableItem } from '../components/reports-table/reports-table.component';
import formatArea from '../utils/formate-number';

export type HistoriesSafrasReportFilters =
  contractInput['historiesSafras']['reports']['list'];
export type HistoriesSafrasReportOutput =
  contractOutput['historiesSafras']['reports']['list'];

// Frontend display types
export interface HistoriesSafrasReportItem extends ReportTableItem {}

// Type for the raw HistoriesSafras entity from the API response
export type HistoriesSafras = HistoriesSafrasReportOutput[0][0]; // Extract the entity type from the tuple

// Type for extended request with organization data
type BatchHistoryRequestWithOrg = HistoriesSafras['batchHistoryRequest'] & {
  organizationName?: string | null;
  userName?: string | null;
};

/**
 * Transform function to convert raw database entities to frontend report items
 */
export function transformHistoriesSafrasToReportItem(
  history: HistoriesSafras,
): HistoriesSafrasReportItem {
  const request = history.batchHistoryRequest as BatchHistoryRequestWithOrg;

  return {
    id: history.id!,
    requestNumber: history.batchHistoryRequest.id!,
    client: request.organizationName ?? '',
    requester: request.userName ?? '',
    requestDate: String(history.batchHistoryRequest.createdDate),
    areaIdentification: history.areaId ?? '',
    area: formatArea(history.areaHa) ?? '',
    city: history.ibgeCity?.nmMun ?? '',
    state: history.ibgeCity?.nmUf ?? '',

    cpfCnpj: history.cpfCnpj ?? '',
    car: history.fileAttributes.car ?? '',
    producer: history.fileAttributes.producer ?? '',

    areaStatus: {
      code: 'unknown', // TODO: Implement actual status logic
      description: 'Status não definido',
    },
    contract: history.fileAttributes.contract ?? '',
    insurancePolicy: history.fileAttributes.insurancePolicy ?? '',
    farmName: history.fileAttributes.farmName ?? '',
  };
}

export type HistoriesSafrasReportResult = [HistoriesSafrasReportItem[], number];
